import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Events, subscribe, publish } from '@conversion-cloud-widget/pubsub';
import { calculateDefaultWidgetHeight, ModuleBarSkins, setWidgetHeight } from '@conversion-cloud-widget/UI';

const StyledButton = styled.div`
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    height: ${props => props.launcherHeight}px;
    padding: 0 8px;

    &.wallet {
        border-left: 1px solid hsla(0, 0%, 0%, 0.08);
        cursor: pointer;
        flex-direction: column;
        padding: 0 16px;
        z-index: 100;

        svg {
            opacity: 0.5;
        }

        span {
            color: hsla(0, 0%, 0%, 0.8);
            display: inline-block;
            font-size: 12px;
            font-family: 'gilroy', sans-serif;
            padding: 4px;
        }
    }
`;

const MoreButton = ({ fill, height, yPosition, skin }) => {
    const [show, setShow] = useState(true);
    const [open, setOpen] = useState(false);

    const handleClick = () => {
        const moduleBar = document.querySelector('#clx-container__module-bar');
        const isOpen = moduleBar.classList.contains('opened');

        if (isOpen) {
            moduleBar.classList.remove('opened');
            moduleBar.removeAttribute('style');
            setOpen(false);
            return;
        }

        if (skin === ModuleBarSkins.DEFAULT) {
            const widgetHeight = calculateDefaultWidgetHeight();

            /* Set the height and margin of the widget */
            const newStyle = `height:${widgetHeight + 8}px; ${
                yPosition === 'bottom' ? `margin-top:-${widgetHeight + 8}px;` : ''
            }`;
            moduleBar.setAttribute('style', newStyle);
            moduleBar.classList.add('opened');
        } else {
            setWidgetHeight(yPosition, skin, height);
        }

        setOpen(true);

        publish('WALLET_MORE_OPEN');
    };

    useEffect(() => {
        subscribe(Events.MODULE_OPENED, () => {
            setShow(false);
        });
        subscribe(Events.MODULE_CLOSED, () => {
            setShow(true);
        });
    }, []);

    return (
        show && (
            <StyledButton
                launcherHeight={height}
                onClick={handleClick}
                className={`clx-container__module-bar__more ${skin === ModuleBarSkins.WALLET ? 'wallet' : 'default'} ${
                    open ? 'opened' : ''
                }`}
            >
                {skin === ModuleBarSkins.WALLET ? (
                    <>
                        <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M1 12H12C12.55 12 13 11.55 13 11C13 10.45 12.55 10 12 10H1C0.45 10 0 10.45 0 11C0 11.55 0.45 12 1 12ZM1 7H9C9.55 7 10 6.55 10 6C10 5.45 9.55 5 9 5H1C0.45 5 0 5.45 0 6C0 6.55 0.45 7 1 7ZM0 1C0 1.55 0.45 2 1 2H12C12.55 2 13 1.55 13 1C13 0.45 12.55 0 12 0H1C0.45 0 0 0.45 0 1ZM17.3 8.88L14.42 6L17.3 3.12C17.69 2.73 17.69 2.1 17.3 1.71C16.91 1.32 16.28 1.32 15.89 1.71L12.3 5.3C11.91 5.69 11.91 6.32 12.3 6.71L15.89 10.3C16.28 10.69 16.91 10.69 17.3 10.3C17.68 9.91 17.69 9.27 17.3 8.88Z"
                                fill="#181818"
                            />
                        </svg>
                        <span>More</span>
                    </>
                ) : (
                    <>
                        <svg height="16" width="16" viewBox="0 0 12.05 6.01">
                            <polyline
                                fill="none"
                                stroke={fill}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2px"
                                points="1 5.01 6.05 1 11.05 5.01"
                            />
                        </svg>
                    </>
                )}
            </StyledButton>
        )
    );
};

export default MoreButton;
